import React from 'react'
import '../styles/sixthcontainer.scss'

const Sixthcontainer = () => {
  return (
    <div className="sixth-container">
      <div className="wrap-all">
        <div className="find-out">
          <h1>Find Out How We Help Students</h1>
        </div>
        <div className="authentic">
          <p>
            authentic 'voice and choice' matter and a big part of this is leaving 'room for interpretation' in the assignment. Those gray areas <br /> can confuse students unaccustomed to agency and choice, but once they become comfortable with it, it can be a significant <br /> factor in helping them show what their 'best'actually is.
          </p>
        </div>
      </div>
      <div className="rect">
        <div className="rectangle">
          <img src="/images/play.png" alt="" boderredius="50%" />
        </div>
      </div>
    </div>
  )
}

export default Sixthcontainer
